/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './report';
import './itemization_report';
import './forecast_report';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "salesreporter": {
        "nested": {
          "service": {
            "nested": {
              "SetTargetsHiddenFromReportingRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "targets": {
                    "type": ".squareup.salesreporter.service.SetTargetsHiddenFromReportingRequest.Target",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "hidden": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Target": {
                    "fields": {
                      "billToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "billEventToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "orderId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SetTargetsHiddenFromReportingResponse": {
                "fields": {
                  "targetsSuccessfullyUpdated": {
                    "type": ".squareup.salesreporter.service.SetTargetsHiddenFromReportingResponse.TargetSuccessfullyUpdated",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "targetsFailedToUpdate": {
                    "type": ".squareup.salesreporter.service.SetTargetsHiddenFromReportingResponse.TargetFailedToUpdate",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "TargetSuccessfullyUpdated": {
                    "fields": {
                      "billToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "billEventToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "orderId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "TargetFailedToUpdate": {
                    "fields": {
                      "billToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "billEventToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "orderId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "errorMessage": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SalesReportsExternalEndpointsService": {
                "methods": {
                  "SalesTrendsReport": {
                    "requestType": ".squareup.salesreporter.service.ReportRequest",
                    "responseType": ".squareup.salesreporter.service.ReportResponse"
                  },
                  "SalesTrendsAvailableFilters": {
                    "requestType": ".squareup.salesreporter.service.AvailableFiltersRequest",
                    "responseType": ".squareup.salesreporter.service.AvailableFiltersResponse"
                  },
                  "SalesSummaryReport": {
                    "requestType": ".squareup.salesreporter.service.ReportRequest",
                    "responseType": ".squareup.salesreporter.service.ReportResponse"
                  },
                  "ItemizationSalesReport": {
                    "requestType": ".squareup.salesreporter.service.ItemizationReportRequest",
                    "responseType": ".squareup.salesreporter.service.ItemizationReportResponse"
                  },
                  "SalesSummaryAvailableFilters": {
                    "requestType": ".squareup.salesreporter.service.AvailableFiltersRequest",
                    "responseType": ".squareup.salesreporter.service.AvailableFiltersResponse"
                  },
                  "ItemizationSalesAvailableFilters": {
                    "requestType": ".squareup.salesreporter.service.ItemizationSalesAvailableFiltersRequest",
                    "responseType": ".squareup.salesreporter.service.ItemizationSalesAvailableFiltersResponse"
                  },
                  "NonTransactionalReport": {
                    "requestType": ".squareup.salesreporter.service.NonTransactionalReportRequest",
                    "responseType": ".squareup.salesreporter.service.NonTransactionalReportResponse"
                  },
                  "PayoutReconciliationReport": {
                    "requestType": ".squareup.salesreporter.service.PayoutReconciliationReportRequest",
                    "responseType": ".squareup.salesreporter.service.PayoutReconciliationReportResponse"
                  },
                  "GetTransferFromPayout": {
                    "requestType": ".squareup.salesreporter.service.GetTransferFromPayoutRequest",
                    "responseType": ".squareup.salesreporter.service.GetTransferFromPayoutResponse"
                  },
                  "ListReportingDetails": {
                    "requestType": ".squareup.salesreporter.service.ListReportingDetailsRequest",
                    "responseType": ".squareup.salesreporter.service.ListReportingDetailsResponse"
                  },
                  "SalesForecastReport": {
                    "requestType": ".squareup.salesreporter.service.SalesForecastReportRequest",
                    "responseType": ".squareup.salesreporter.service.SalesForecastReportResponse"
                  },
                  "SetTargetsHiddenFromReporting": {
                    "requestType": ".squareup.salesreporter.service.SetTargetsHiddenFromReportingRequest",
                    "responseType": ".squareup.salesreporter.service.SetTargetsHiddenFromReportingResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SetTargetsHiddenFromReportingRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SetTargetsHiddenFromReportingRequest?.nested?.Target && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SetTargetsHiddenFromReportingResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SetTargetsHiddenFromReportingResponse?.nested?.TargetSuccessfullyUpdated && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SetTargetsHiddenFromReportingResponse?.nested?.TargetFailedToUpdate && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SalesReportsExternalEndpointsService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SetTargetsHiddenFromReportingRequest @ squareup/salesreporter/service.proto at 163:1
 */
export const SetTargetsHiddenFromReportingRequest = $root.lookupType('squareup.salesreporter.service.SetTargetsHiddenFromReportingRequest');
fixType(SetTargetsHiddenFromReportingRequest, {
  merchantToken: {
    notEmpty: true
  },
  targets: {
    required: true
  },
  hidden: {
    required: true
  }
});
Builder.createAndAttachToType(SetTargetsHiddenFromReportingRequest);
/**
 * SOURCE Target @ squareup/salesreporter/service.proto at 164:3
 */
SetTargetsHiddenFromReportingRequest.Target = $root.lookupType('squareup.salesreporter.service.SetTargetsHiddenFromReportingRequest.Target');
fixType(SetTargetsHiddenFromReportingRequest.Target);
Builder.createAndAttachToType(SetTargetsHiddenFromReportingRequest.Target);
/**
 * SOURCE SetTargetsHiddenFromReportingResponse @ squareup/salesreporter/service.proto at 179:1
 */
export const SetTargetsHiddenFromReportingResponse = $root.lookupType('squareup.salesreporter.service.SetTargetsHiddenFromReportingResponse');
fixType(SetTargetsHiddenFromReportingResponse);
Builder.createAndAttachToType(SetTargetsHiddenFromReportingResponse);
/**
 * SOURCE TargetSuccessfullyUpdated @ squareup/salesreporter/service.proto at 180:3
 */
SetTargetsHiddenFromReportingResponse.TargetSuccessfullyUpdated = $root.lookupType('squareup.salesreporter.service.SetTargetsHiddenFromReportingResponse.TargetSuccessfullyUpdated');
fixType(SetTargetsHiddenFromReportingResponse.TargetSuccessfullyUpdated);
Builder.createAndAttachToType(SetTargetsHiddenFromReportingResponse.TargetSuccessfullyUpdated);
/**
 * SOURCE TargetFailedToUpdate @ squareup/salesreporter/service.proto at 191:3
 */
SetTargetsHiddenFromReportingResponse.TargetFailedToUpdate = $root.lookupType('squareup.salesreporter.service.SetTargetsHiddenFromReportingResponse.TargetFailedToUpdate');
fixType(SetTargetsHiddenFromReportingResponse.TargetFailedToUpdate);
Builder.createAndAttachToType(SetTargetsHiddenFromReportingResponse.TargetFailedToUpdate);
/**
 * SOURCE SalesReportsExternalEndpointsService @ squareup/salesreporter/service.proto at 17:1
 */
export const SalesReportsExternalEndpointsService = $root.lookupService('squareup.salesreporter.service.SalesReportsExternalEndpointsService');